<svg
  [ngStyle]="styleList"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.5"
    y="1.5"
    width="61"
    height="61"
    [attr.rx]="rx"
    fill="url(#paint0_linear_3055_2285)"
    stroke="#FEFEFE"
    stroke-width="3"
  />

  <path
    opacity="0.78"
    d="M32 51.5C42.7696 51.5 51.5 42.7696 51.5 32C51.5 21.2304 42.7696 12.5 32 12.5C21.2304 12.5 12.5 21.2304 12.5 32C12.5 42.7696 21.2304 51.5 32 51.5Z"
    stroke="url(#paint1_radial_3055_2285)"
  />
  <path
    d="M13.5019 50.1231L13.503 50.1069L13.503 50.0906L13.503 43.7094C13.5121 43.6159 13.5533 43.5285 13.6193 43.4623L28.1688 28.8631C28.5311 28.4996 28.6541 27.9804 28.5431 27.5058C27.6872 23.8476 28.7151 19.7855 31.6148 16.8759C36.0257 12.4499 43.0684 12.3724 47.3457 16.6643C51.624 20.9573 51.5467 28.0268 47.1349 32.4536C44.2352 35.3632 40.1883 36.3937 36.5446 35.5352C36.0697 35.4234 35.5508 35.5476 35.1883 35.9114L31.3616 39.7511C31.2875 39.8255 31.1876 39.8676 31.0834 39.869L27.6318 39.9134C26.8703 39.9232 26.2581 40.5398 26.2484 41.2999L26.2107 44.2495C26.2079 44.4688 26.0331 44.6435 25.8191 44.6488L22.8478 44.6151L22.8478 44.6149L22.8356 44.6151C21.9998 44.6258 21.4999 45.3944 21.4912 46.0733L21.4912 46.0733L21.4406 50.0842C21.4406 50.0842 21.4406 50.0843 21.4406 50.0843C21.4396 50.156 21.4035 50.2507 21.3105 50.3412C21.2226 50.4268 21.1109 50.4807 21.0101 50.4953H13.8263H13.8023L13.7784 50.4976C13.6406 50.5108 13.593 50.469 13.5718 50.4444C13.5388 50.4063 13.4898 50.3087 13.5019 50.1231ZM44.8825 19.1407C43.3987 17.6518 40.9773 17.6961 39.4773 19.2011C37.9783 20.7053 37.9343 23.1321 39.4171 24.6199C40.9009 26.1088 43.3224 26.0645 44.8223 24.5595C46.3214 23.0553 46.3654 20.6285 44.8825 19.1407Z"
    fill="url(#paint2_linear_3055_2285)"
    stroke="url(#paint3_linear_3055_2285)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_3055_2285"
      x1="37.5"
      y1="64.0004"
      x2="-64.6232"
      y2="47.3419"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="#EBECF7"
      />
    </linearGradient>
    <radialGradient
      id="paint1_radial_3055_2285"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(13 14) rotate(60.141) scale(31.1328)"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </radialGradient>
    <linearGradient
      id="paint2_linear_3055_2285"
      x1="21.3499"
      y1="26.4674"
      x2="76.8294"
      y2="22.8207"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint3_linear_3055_2285"
      x1="8.03381"
      y1="37.3237"
      x2="28.2615"
      y2="44.3941"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
  </defs>
</svg>
